import { Component } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { PermissionEnforcer } from './services/permission-enforcer.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent {
    constructor(private AuthService: AuthService, private permissionEnforcer: PermissionEnforcer) {}
    isHidden: any = false;
    shouldOpenSideMenu = false;
    beforeInstallPromptEvent;
    async ngOnInit() {
        await this.AuthService.autoAuthUser();
        this.AuthService.isBool.subscribe((response: Boolean) => {
            this.isHidden = true;
        });

        // window.addEventListener(
        //     'beforeinstallprompt',
        //     ((event: any) => {
        //         this.beforeInstallPromptEvent = event;
        //     }).bind(this),
        // );
        // this.showInstallPrompt = this.showInstallPrompt.bind(null, this); //not binding 'this' to thisArg, as it is taking the context out of user gesture, causing the prompt to not appear.
        // window.addEventListener('click', this.showInstallPrompt);
    }

    // showInstallPrompt(that) {
    //     if (that.beforeInstallPromptEvent) {
    //         // that.beforeInstallPromptEvent.prompt();
    //         window.removeEventListener('click', that.showInstallPrompt);
    //     }
    // }

    toggleSideMenuEventHandler(event) {
        this.shouldOpenSideMenu = event;
    }

    sideNavItemClickedEventHandler(event) {
        this.shouldOpenSideMenu = false;
    }
}
